import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";


@Injectable()
export class NotificationService {

  //The observables get subscribed upon on in the notification.component.ts
  private messagesSource = new Subject<{title: string, message: string}>();
  messages: Observable<{title: string, message: string}> = this.messagesSource.asObservable();

  private errorsSource = new Subject<string>();
  errors: Observable<string> = this.errorsSource.asObservable();

  private badRequestSource = new Subject<string>();
  badRequests: Observable<string> = this.badRequestSource.asObservable();

  private serverErrorSource = new Subject<string>();
  serverErrors: Observable<string> = this.serverErrorSource.asObservable();

  private conflictErrorSource = new Subject<string>();
  conflictErrors: Observable<string> = this.conflictErrorSource.asObservable();

  private UnauthorizedErrorSource = new Subject<string>();
  unauthorizedErrors: Observable<string> = this.UnauthorizedErrorSource.asObservable();

  private permissionErrorSource = new Subject<string>();
  permissionErrors: Observable<string> = this.permissionErrorSource.asObservable();

  private requestSource = new Subject<boolean>();
  httpActivity: Observable<boolean> = this.requestSource.asObservable();

  private httpRequestCounter = 0;


  constructor() {
  }

  notify(title: string, message: string) {
    this.messagesSource.next({title, message});
  }

  notifyError(message: string) {          // 400: http error
    this.errorsSource.next(message);
  }

  notifyBadRequest(message: string) {     // 400 + field errors
    this.badRequestSource.next(message);
  }

  notifyServerError(message: string) {    // 503: service not available error and unmapped errors.
    this.serverErrorSource.next(message);
  }

  notifyUnauthorizedError(message: string) { // 401: Unauthorized
    this.UnauthorizedErrorSource.next(message);
  }

  notifyPermissionError(message: string) { // 403: permission error.
    this.permissionErrorSource.next(message);
  }

  notifyConflictError(message: string) {   // 409: conflict error.
    this.conflictErrorSource.next(message);
  }

  notifyRequestStart() {
    this.httpRequestCounter++;
    this.requestSource.next(this.httpRequestCounter > 0);
  }

  notifyRequestEnd() {
    this.httpRequestCounter--;
    this.requestSource.next(this.httpRequestCounter > 0);
  }


}
